<div class="filter-bar">
    <form
        [formGroup]="filterForm"
        *ngIf="
            filterComponentName === 'tickets' ||
            filterComponentName === 'events'
        "
    >
        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="date"
            type="button"
            (click)="saveCurrentDate()"
        >
            Date
        </button>
        <mat-menu #date="matMenu">
            <mat-form-field
                appearance="fill"
                class="unified-date-field"
            >
                <mat-label>Start date</mat-label>
                <input
                    matInput
                    [matDatepicker]="startPicker"
                    formControlName="start_date"
                    [max]="defaultDate"
                    (dateChange)="changeDateInput()"
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="startPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field
                appearance="fill"
                class="unified-date-field"
            >
                <mat-label>End date</mat-label>
                <input
                    matInput
                    [matDatepicker]="endPicker"
                    formControlName="end_date"
                    [max]="defaultDate"
                    [value]="defaultDate"
                    [value]="defaultDate"
                    (dateChange)="changeDateInput()"
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="endPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field
                appearance="fill"
                (click)="$event.stopPropagation()"
            >
                <mat-label>Choose predefined range</mat-label>
                <mat-select
                    #predefinedDate
                    formControlName="predefined_date"
                    (selectionChange)="onPredefinedChange($event)"
                    disableOptionCentering
                    md-container-class="mySelect"
                >
                    <mat-option
                        *ngFor="let predef of predefinedDateOptions"
                        [value]="predef.value"
                    >
                        {{ predef.viewValue }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-raised-button>OK</button>
        </mat-menu>

        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="ticketStatus"
            type="button"
            *ngIf="filterComponentName == 'tickets'"
        >
            Ticket Status
        </button>
        <mat-menu #ticketStatus="matMenu">
            <section>
                <button (click)="$event.stopPropagation(); selectAll('status')">
                    Select All
                </button>
                <button
                    (click)="$event.stopPropagation(); uncheckAll('status')"
                >
                    Unselect
                </button>
            </section>
            <section
                class="example-section"
                (click)="$event.stopPropagation()"
            >
                <mat-checkbox
                    class="example-margin"
                    *ngFor="let tStatus of tStatuses"
                    [value]="tStatus.val"
                    (change)="onStatusChecked(tStatus.val, tStatus.selected)"
                    [checked]="tStatus.selected"
                    >{{ tStatus.viewValue }}
                </mat-checkbox>
            </section>
            <button mat-raised-button>OK</button>
        </mat-menu>

        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="location"
            *ngIf="
                (deviceChosen == 'shop' || deviceChosen == 'SSBT') &&
                filterComponentName == 'tickets'
            "
            type="button"
        >
            Location
        </button>
        <mat-menu #location="matMenu">
            <section
                class="example-section"
                (click)="$event.stopPropagation()"
            >
                <mat-checkbox
                    class="example-margin"
                    *ngFor="let location of locations"
                    [value]="location.shop_id"
                    (change)="
                        onShopChecked(location.shop_id, false);
                        setSelectedLocation(location)
                    "
                    [checked]="location.selected"
                >
                    {{ location.shop_name + ' , ' + location.location_id }}
                </mat-checkbox>
            </section>
            <button mat-raised-button>OK</button>
        </mat-menu>

        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="userId"
            *ngIf="deviceChosen == 'shop' && filterComponentName == 'tickets'"
            type="button"
        >
            POS - ATN Name
        </button>
        <mat-menu #userId="matMenu">
            <div formArrayName="user_ids">
                <section
                    class="example-section"
                    (click)="$event.stopPropagation()"
                    *ngFor="let user of users; let i = index"
                >
                    <mat-checkbox
                        class="example-margin"
                        [value]="user.user_id"
                        (change)="
                            onUserChecked(user.user_id); setSelectedUser(user)
                        "
                        [checked]="user.selected"
                        [disabled]="user.hide"
                        >{{ user.user }}</mat-checkbox
                    >
                </section>
            </div>
            <button mat-raised-button>OK</button>
        </mat-menu>

        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="userUuid"
            *ngIf="deviceChosen == 'web' && filterComponentName == 'tickets'"
            type="button"
        >
            User ID
        </button>
        <mat-menu #userUuid="matMenu">
            <p>User ID</p>
            <mat-form-field
                class="example-full-width"
                appearance="fill"
            >
                <mat-label>User ID</mat-label>
                <input
                    (input)="onPaste($event)"
                    matInput
                    placeholder="31f806f-82db-4631-..."
                    (click)="$event.stopPropagation()"
                    formControlName="userUuid"
                />
            </mat-form-field>
            <button mat-raised-button>OK</button>
        </mat-menu>

        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="kiosk_id"
            *ngIf="deviceChosen == 'SSBT' && filterComponentName == 'tickets'"
            type="button"
        >
            Kiosk ID
        </button>
        <mat-menu #kiosk_id="matMenu">
            <section>
                <button
                    (click)="$event.stopPropagation(); selectAll('terminal')"
                >
                    Select All
                </button>
                <button
                    (click)="$event.stopPropagation(); uncheckAll('terminal')"
                >
                    Unselect
                </button>
            </section>
            <section
                class="example-section"
                (click)="$event.stopPropagation()"
            >
                <mat-checkbox
                    class="example-margin"
                    *ngFor="let kiosk of kiosks"
                    [value]="kiosk.terminal_id"
                    (change)="onKioskChecked(kiosk.terminal_id)"
                    [checked]="kiosk.selected"
                    [disabled]="kiosk.hide"
                >
                    {{ kiosk.terminal }}</mat-checkbox
                >
            </section>
            <button mat-raised-button>OK</button>
        </mat-menu>

        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="posTerminalId"
            *ngIf="deviceChosen == 'shop' && filterComponentName == 'tickets'"
            type="button"
        >
            POS Terminal ID
        </button>
        <mat-menu #posTerminalId="matMenu">
            <p>POS Terminal ID</p>
            <mat-form-field
                class="example-full-width"
                appearance="fill"
            >
                <mat-label>POS Terminal ID</mat-label>
                <input
                    matInput
                    placeholder="31f806f-82db-4631-..."
                    (click)="$event.stopPropagation()"
                    formControlName="terminal_id"
                />
            </mat-form-field>
            <button mat-raised-button>OK</button>
        </mat-menu>
        <div class="ticket-code-search">
            <mat-form-field
                *ngIf="filterComponentName === 'tickets'"
                class="ticket-code-search-label"
            >
                <input
                    matInput
                    placeholder="Enter userUuid"
                    (input)="onPaste($event)"
                    formControlName="user_uuid"
                    aria-label="Search"
                    #searchInput
                />
            </mat-form-field>
        </div>

        <button
            class="ticket-code-search-button"
            mat-raised-button
            color="primary"
            (click)="search()"
        >
            Search
        </button>

        <button
            mat-raised-button
            color="primary"
            type="submit"
            (click)="resetFilters()"
        >
            Reset filters
        </button>
    </form>

    <!-- Overlay koji blokira sve klikove osim na modal -->
    <div
        class="modal-overlay"
        [class.show]="isModalVisible"
    ></div>

    <!-- Modalni prozor -->
    <div
        id="customModal"
        class="modal"
        [class.show]="isModalVisible"
        cdkDrag
    >
        <div class="modal-content">
            <!-- Dugme za zatvaranje modala -->
            <div>
                <span
                    class="close"
                    (click)="closeModal()"
                    >&times;</span
                >
            </div>
            <div class="iframe_content">
                <iframe
                    [src]="iframeUrl"
                    width="100%"
                    height="100%"
                    boreder="none"
                    sandbox="allow-same-origin allow-scripts"
                >
                </iframe>
            </div>
        </div>
    </div>
</div>
